(function() {
  'use strict';

  function initCollection(root) {
    if (!root || root.__edmeInit) return;
    root.__edmeInit = true;

    var body = root.querySelector('[data-col-body]');
    var grid = root.querySelector('[data-product-grid]');
    var toggleBtn = root.querySelector('[data-filter-toggle]');
    var overlay = root.querySelector('[data-filter-overlay]');
    var defaultOpen = root.getAttribute('data-filter-default-open') === 'true';

    root.classList.add('is-ready');

    var gridSwapTimer = null;

    function setFilterState(open, skipAnimation) {
      if (!body) return;

      if (open) {
        body.classList.add('is-filter-open');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');

        if (window.innerWidth <= 990 && overlay) {
          overlay.hidden = false;
          requestAnimationFrame(function() { overlay.classList.add('is-visible'); });
          document.body.style.overflow = 'hidden';
        } else {
          if (gridSwapTimer) clearTimeout(gridSwapTimer);
          if (skipAnimation) {
            if (grid) grid.classList.add('is-cols-filtered');
          } else {
            gridSwapTimer = setTimeout(function() {
              if (grid) grid.classList.add('is-cols-filtered');
            }, 180);
          }
        }
      } else {
        body.classList.remove('is-filter-open');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');

        if (overlay) {
          overlay.classList.remove('is-visible');
          setTimeout(function() { overlay.hidden = true; }, 300);
          document.body.style.overflow = '';
        }

        if (window.innerWidth > 990) {
          if (gridSwapTimer) clearTimeout(gridSwapTimer);
          if (grid) grid.classList.remove('is-cols-filtered');
        } else {
          if (grid) grid.classList.remove('is-cols-filtered');
        }
      }
    }

    var initialOpen = defaultOpen;
    if (window.innerWidth <= 990) initialOpen = false;
    setFilterState(initialOpen, true);

    if (toggleBtn && !toggleBtn.disabled) {
      toggleBtn.addEventListener('click', function() {
        var isOpen = body.classList.contains('is-filter-open');
        setFilterState(!isOpen, false);
      });
    }
    if (overlay) overlay.addEventListener('click', function() { setFilterState(false, false); });

    var closeBtn = root.querySelector('[data-filter-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setFilterState(false, false);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && body.classList.contains('is-filter-open')) {
        setFilterState(false, false);
      }
    });

    var lastIsMobile = window.innerWidth <= 990;
    window.addEventListener('resize', function() {
      var nowIsMobile = window.innerWidth <= 990;
      if (nowIsMobile !== lastIsMobile) {
        lastIsMobile = nowIsMobile;
        if (nowIsMobile) {
          document.body.style.overflow = '';
          if (body.classList.contains('is-filter-open')) setFilterState(false, true);
        }
      }
    });

    var sortWrap = root.querySelector('[data-sort-wrapper]');
    var sortBtn = root.querySelector('[data-sort-btn]');
    var sortMenu = root.querySelector('[data-sort-menu]');
    if (sortBtn && sortMenu) {
      sortBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = !sortMenu.hidden;
        sortMenu.hidden = isOpen;
        sortBtn.setAttribute('aria-expanded', String(!isOpen));
        if (sortWrap) sortWrap.setAttribute('data-open', String(!isOpen));
      });
      document.addEventListener('click', function(e) {
        if (sortWrap && !sortWrap.contains(e.target)) {
          sortMenu.hidden = true;
          sortBtn.setAttribute('aria-expanded', 'false');
          sortWrap.setAttribute('data-open', 'false');
        }
      });
      sortMenu.querySelectorAll('[data-sort-value]').forEach(function(li) {
        li.addEventListener('click', function() {
          var val = li.getAttribute('data-sort-value');
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', val);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
    }

    var filterForm = root.querySelector('[data-filter-form]');
    if (filterForm) {
      var debounceTimer;
      filterForm.addEventListener('change', function(e) {
        if (e.target.matches('input[type="checkbox"]')) submitFilterForm();
      });
      filterForm.addEventListener('input', function(e) {
        if (e.target.matches('input[type="number"]')) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(submitFilterForm, 650);
        }
      });
      function submitFilterForm() {
        var formData = new FormData(filterForm);
        var params = new URLSearchParams();
        formData.forEach(function(value, key) {
          if (value !== '' && value !== null) params.append(key, value);
        });
        var currentUrl = new URL(window.location.href);
        var sortBy = currentUrl.searchParams.get('sort_by');
        if (sortBy) params.set('sort_by', sortBy);
        var newUrl = window.location.pathname + '?' + params.toString();
        window.location.href = newUrl;
      }
    }

    root.querySelectorAll('.edme-pcard').forEach(function(card) { initProductCard(card); });

    // === RELATED COLORS PANEL ===
    initRelatedPanel(root);
  }

  function initRelatedPanel(root) {
    var panel = root.querySelector('[data-related-panel]');
    var overlay = root.querySelector('[data-related-overlay]');
    var body = root.querySelector('[data-related-body]');
    var closeBtn = root.querySelector('[data-related-close]');
    var titleEl = root.querySelector('#edme-related-title');

    if (!panel || !overlay || !body) return;

    function openPanel(productsData) {
      // Body'yi doldur
      body.innerHTML = renderRelatedGrid(productsData);

      // Scrollbar genişliğini hesapla ve telafi et (sayfa oynamasın)
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
        // Sticky/fixed header'ı da telafi et
        var stickyHeader = document.querySelector('.header-wrapper, .section-header, header[role="banner"], .shopify-section-header');
        if (stickyHeader) {
          stickyHeader.style.paddingRight = scrollbarWidth + 'px';
          stickyHeader.setAttribute('data-edme-scrollbar-comp', '1');
        }
      }

      // Aç
      overlay.hidden = false;
      requestAnimationFrame(function() {
        overlay.classList.add('is-visible');
        panel.classList.add('is-open');
      });
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePanel() {
      panel.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      // Sticky header telafisini geri al
      var compHeader = document.querySelector('[data-edme-scrollbar-comp="1"]');
      if (compHeader) {
        compHeader.style.paddingRight = '';
        compHeader.removeAttribute('data-edme-scrollbar-comp');
      }
      setTimeout(function() {
        overlay.hidden = true;
        body.innerHTML = '';
      }, 380);
    }

    function renderRelatedGrid(items) {
      if (!items || !items.length) {
        return '<p style="text-align:center; color:#6B6B6B; padding:40px 0; font-size:12px;">Diğer renk bulunamadı.</p>';
      }
      var html = '<div class="edme-col__related-grid">';
      items.forEach(function(item) {
        var colorName = item.color || '';
        var nameHtml = colorName
          ? '<p class="edme-col__related-name">' + escapeHtml(colorName) + '</p>'
          : '<p class="edme-col__related-name edme-col__related-name--empty">' + escapeHtml(item.title || '') + '</p>';
        var imgSrc = item.image || '';

        html += '<a href="' + escapeAttr(item.url) + '" class="edme-col__related-item">';
        html += '  <div class="edme-col__related-thumb">';
        if (imgSrc) {
          html += '    <img src="' + escapeAttr(imgSrc) + '" alt="' + escapeAttr(item.title || '') + '" loading="lazy">';
        }
        html += '  </div>';
        html += nameHtml;
        html += '</a>';
      });
      html += '</div>';
      return html;
    }

    function escapeHtml(s) {
      if (s == null) return '';
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
    function escapeAttr(s) {
      if (s == null) return '';
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    // Trigger handler — ürün kartlarındaki [data-related-trigger] butonları
    root.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-related-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();

      var raw = trigger.getAttribute('data-related-products');
      if (!raw) return;

      try {
        // Attribute escape edildi, parse et
        var parser = new DOMParser();
        var decoded = parser.parseFromString(raw, 'text/html').documentElement.textContent;
        var products = JSON.parse(decoded);
        openPanel(products);
      } catch (err) {
        console.error('[EDME] Related products parse error:', err);
      }
    });

    // Close
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closePanel();
      });
    }
    if (overlay) {
      overlay.addEventListener('click', closePanel);
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        closePanel();
      }
    });
  }

  function initProductCard(card) {
    if (card.__edmeInit) return;
    card.__edmeInit = true;

    var primaryImg = card.querySelector('[data-pcard-primary]');
    var colorNameEl = card.querySelector('[data-pcard-color-label]');
    var sizesContainer = card.querySelector('[data-pcard-sizes]');
    var fallbackUrl = card.getAttribute('data-product-url');

    var swatches = card.querySelectorAll('.edme-pcard__swatch');

    swatches.forEach(function(sw) {
      sw.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        swatches.forEach(function(s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');

        var newImg = sw.getAttribute('data-swatch-image');
        var colorName = sw.getAttribute('data-color-value') || '';

        if (newImg && primaryImg) {
          primaryImg.src = newImg;
          primaryImg.removeAttribute('srcset');
        }
        if (colorNameEl && colorName) {
          colorNameEl.textContent = colorName.toLowerCase();
        }

        // Carousel mode → ilk slide'a dön
        if (card.hasAttribute('data-pcard-carousel')) {
          var track = card.querySelector('[data-pcard-track]');
          var slides = card.querySelectorAll('.edme-pcard__slide');
          var dots = card.querySelectorAll('[data-dot-index]');
          if (track) track.style.transform = 'translateX(0%)';
          slides.forEach(function(s, i) { s.classList.toggle('is-active', i === 0); });
          dots.forEach(function(d, i) { d.classList.toggle('is-active', i === 0); });
        }
      });
    });

    if (sizesContainer) {
      sizesContainer.querySelectorAll('.edme-pcard__size').forEach(function(sz) {
        sz.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (sz.disabled) return;
          var variantId = sz.getAttribute('data-variant-id');
          if (variantId && fallbackUrl) {
            var sep = fallbackUrl.indexOf('?') > -1 ? '&' : '?';
            window.location.href = fallbackUrl + sep + 'variant=' + variantId;
          }
        });
      });
    }

    card.querySelectorAll('img').forEach(function(img) {
      img.addEventListener('dragstart', function(e) { e.preventDefault(); });
    });

    // === CAROUSEL LOGIC ===
    if (card.hasAttribute('data-pcard-carousel')) {
      initCarousel(card);
    }
  }

  function initCarousel(card) {
    var media = card.querySelector('.edme-pcard__media');
    var track = card.querySelector('[data-pcard-track]');
    if (!media || !track) return;

    var slides = track.querySelectorAll('.edme-pcard__slide');
    var slideCount = slides.length;
    if (slideCount <= 1) return;

    var dots = card.querySelectorAll('[data-dot-index]');
    var prevBtn = card.querySelector('[data-pcard-prev]');
    var nextBtn = card.querySelector('[data-pcard-next]');
    var link = card.querySelector('[data-pcard-link]');

    var currentIndex = 0;
    var isDesktop = window.matchMedia('(hover: hover)').matches && window.innerWidth > 990;

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx >= slideCount) idx = slideCount - 1;
      currentIndex = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';

      slides.forEach(function(s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      updateArrows();
    }

    function updateArrows() {
      if (prevBtn) {
        prevBtn.setAttribute('aria-disabled', currentIndex === 0 ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.setAttribute('aria-disabled', currentIndex === slideCount - 1 ? 'true' : 'false');
      }
    }

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    }

    // Dot clicks
    dots.forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        goTo(idx);
      });
    });

    // === DESKTOP: Mouse zone hover devre dışı (sadece ok'lar kullanılacak) ===
    // (önceden mousemove ile slide değişiyordu, kullanıcı isteğiyle kaldırıldı)

    // === MOBILE: Touch swipe ===
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var isSwiping = false;

    media.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      isSwiping = false;
    }, { passive: true });

    media.addEventListener('touchmove', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      var dx = Math.abs(touchEndX - touchStartX);
      var dy = Math.abs(touchEndY - touchStartY);
      // Yatay hareket daha baskın → swipe niyeti
      if (dx > dy && dx > 10) {
        isSwiping = true;
      }
    }, { passive: true });

    media.addEventListener('touchend', function(e) {
      if (!isSwiping) return;
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      var threshold = 40;

      if (diff > threshold) {
        // Sola swipe → sonraki
        goTo(currentIndex + 1);
      } else if (diff < -threshold) {
        // Sağa swipe → önceki
        goTo(currentIndex - 1);
      }
    }, { passive: true });

    // Swipe sırasında <a> tıklamasını engelle (sadece swipe gerçekleşmişse)
    if (link) {
      link.addEventListener('click', function(e) {
        if (isSwiping) {
          e.preventDefault();
          isSwiping = false;
        }
      });
    }

    // Initial state
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-edme-collection]').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('[data-edme-collection]').forEach(function(el) {
        el.__edmeInit = false;
        initCollection(el);
      });
    }
  });
})();
